import { useState, useEffect } from 'react';

// Single source of truth for "are we on a phone-sized screen", matching the
// 768px breakpoint the stylesheet uses. Prefer CSS wherever it can do the
// job — this exists for the cases it cannot reach, chiefly Recharts props,
// which become SVG geometry rather than styles.
//
// Uses matchMedia rather than a resize listener: it fires only when the
// breakpoint is actually crossed, not on every resize frame.
const QUERY = '(max-width: 767px)';

export default function useIsMobile() {
  const [mobile, setMobile] = useState(
    () => (typeof window === 'undefined' ? false : window.matchMedia(QUERY).matches)
  );

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const handler = (e) => setMobile(e.matches);
    setMobile(mql.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return mobile;
}
